export default "__VITE_ASSET__637e56b6__"